module.exports = __webpack_public_path__ + "img/tuts-rating-page-background-mobile.5ca09d94.png";